import React from "react";
import {useDispatch} from "react-redux";
import {renewToken} from "../../../redux_slices/authenticationSlice";
import {useTranslation} from "react-i18next";
import {postContext} from "../../../redux_slices/contextSlice";
import TermsAndConditionsContent from "./TermsAndConditionsContent";

const TermsAndConditionsChallenge = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onChangeConnection = async () => {
        await dispatch(
            postContext({
                challenge: "termsAndConditions",
            })
        ).then(() => dispatch(renewToken()));
    };

    return (
        <div className={"card-body"}>
            <div className="d-flex flex-column m-auto login_first_welcome">
                <h2>{t("TERMSCONDITIONS.HI")}</h2>
                <TermsAndConditionsContent />
                <div className="d-flex align-items-center agree_checkbox">
                    <input
                        className="form-check-input ml-1 h-40px w-40px cursor-pointer"
                        id="check"
                        type="checkbox"
                        onChange={e => {
                            if (e.target.checked) {
                                onChangeConnection();
                            }
                        }}
                    />
                    <label className="form-check-label ml-24 cursor-pointer" htmlFor="check">
                        {t("TERMSCONDITIONS.AGREE")}
                    </label>
                </div>
            </div>
        </div>
    );
};
export default TermsAndConditionsChallenge;
